class Target {
    constructor() {
        this.sizeLimit = 54975581388800;
    }

    static getSearchKey() {
        return 'target_name';
    }

    static getTargetTypeKey() {
        return 'target_kind';
    }

    static getTargetTypeOptions() {
        return [
            { label: 'Storage', value: 'Storage' },
            { label: 'StorageV2', value: 'StorageV2' },
            { label: 'BlockBlobStorage', value: 'BlockBlobStorage' },
        ];
    }

    static getHealthKey() {
        return 'health';
    }

    static getHealthOptions() {
        return [
            { label: 'Ok', value: 'GREEN' },
            { label: 'Warning', value: 'YELLOW' },
            { label: 'Error', value: 'RED' },
            { label: 'Undefined', value: 'GREY' },
        ];
    }

    static getSizeKey() {
        return 'advertisedCapacityInBytes';
    }

    static getUtilizationKey() {
        return 'controllerUtilizationPct';
    }

    static getDefaultSizeInBytes() {
        return 50 * 1024 * 1024 * 1024 * 1024;
    }

    static fromRaw(raw) {
        const target = new Target();

        target.uuid = raw.uuid;
        target.id = raw.id;
        target.name = raw.name;
        target.location_name = raw.location;
        target.kind = raw.kind;
        target.targetsubscriptionId = raw.targetsubscriptionId;
        target.subscriptionName = raw.subscriptionName;
        target.isAutoCreated = raw.isAutoCreated ? raw.isAutoCreated : raw.autoCreated;
        target.state = raw.state;
        target.health = raw.health;
        target.utilization = raw.utilization;
        target.sizeLimit = raw.sizeLimit;
        target.sizeUsed = raw.sizeUsed;
        target.azurePortalUrl = raw.azurePortalUrl;
        target.publiclyAccessible = raw.publiclyAccessible;
        target.created = moment(raw.created).local().format('YYYY-MM-DD HH:mm:ss');
        target.modified = moment(raw.modified).local().format('YYYY-MM-DD HH:mm:ss');

        return target;
    }

    toRaw() {
        return {
            targetName: this.targetName,
            targetsubscriptionId: this.targetsubscriptionId,
            sizeLimit: this.sizeLimit,
        };
    }
}

module.exports = Target;



// WEBPACK FOOTER //
// ./src/azurebackup/model/Target.js